import { Component, Input } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { NbCheckboxModule } from '@nebular/theme';
import { TranslateModule } from '@ngx-translate/core';
import { CheckboxInput } from './../../../models/inputs/checkbox-input';
import { BaseInputComponent } from './../base-input/base-input.component';

@Component({
	selector: 'app-checkbox-input',
	styles: [
		`
			nb-checkbox {
				display: block;
				padding: 1rem 0;
			}
		`
	],
	template: `
		<nb-checkbox
			[attr.id]="controlId"
			[status]="control.colorStatus"
			[formControl]="control"
			>{{ control.label | translate }}
		</nb-checkbox>
	`,
	standalone: true,
	imports: [NbCheckboxModule, ReactiveFormsModule, TranslateModule]
})
export class CheckboxInputComponent extends BaseInputComponent {
	@Input({ required: true }) override control: CheckboxInput;
}
